import { Col, Drawer, Form, Input, Row, Select, message, Upload, DatePicker, InputNumber, Radio  } from "antd"; 
import { useEffect, useState } from "react";
import CustomUpload from "./CustomUpload";

const ReviseCreditThreshold = ({props}) => {
    const { isOpen, setIsOpen, type, form, handleSave } = props;
  
    const [action, setAction] = useState(null);
    const [amount, setAmount] = useState('');
    //const [newAmount, setNewAmount] = useState(0);

    const handleActionChange = e => {
        setAction(e.target.value);
    };

    const handleAmountChange = e => {
        const amountValue = e.target.value;
        setAmount(amountValue);
        calculateNewValue(action, amountValue);
    };

    const calculateNewValue = (action, amount) => {
    const currentLimit = parseFloat(form.getFieldValue('limit')) || 0;
    const amountValue = parseFloat(amount) || 0;

    if (action === 'increase') {
        //setNewAmount(currentLimit + amountValue);
        form.setFieldValue('newSecurityLimit', currentLimit + amountValue);
    } else if (action === 'decrease') {
        //setNewAmount(currentLimit - amountValue);
        form.setFieldValue('newSecurityLimit', currentLimit - amountValue);
    }
    };

    return (
        <>
            { type === "Revise" ? (
                <>
                {/* Company Limits Revision */}
                <Row>
                    <Col style={{ width: "100%", marginBottom: "10px" }}>
                    <Form.Item>
                        <Row
                        style={{
                            color: "#cacaca",
                            alignItems: "center",
                            fontSize: "15px",
                        }}
                        >
                        <Col
                            span={22}
                            style={{ textAlign: "left", width: "100%" }}
                        >
                            Company Limits Revision
                        </Col>
                        </Row>
                    </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col style={{ width: "100%", marginBottom: "10px" }}>
                    <label htmlFor="label" className="labelInput">
                        Current Company Limit
                    </label>
                    <Form.Item
                        name="limit"
                        hasFeedback
                        rules={[
                        {
                            required: true,
                            message: "Company Limit is required",
                        }
                        ]}
                    >
                        <Input className="inputForm" prefix="RM" disabled/>
                    </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col style={{ width: "100%", marginBottom: "10px" }}>
                    <label htmlFor="label" className="labelInput">
                        New Company limits <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                        //name="limit"
                        hasFeedback
                        rules={[
                        {
                            required: true,
                            message: "Company Limit is required",
                        }
                        ]}
                    >
                        <Input className="inputForm" type="number" prefix="RM"/>
                    </Form.Item>
                    </Col>
                </Row>

                <Row>
                    <Col style={{ width: "100%", marginBottom: "10px" }}>
                    <Form.Item>
                        <Row
                        style={{
                            color: "#cacaca",
                            alignItems: "center",
                            fontSize: "15px",
                        }}
                        >
                        <Col
                            span={22}
                            style={{ textAlign: "left", width: "100%" }}
                        >
                            Security Deposits Revision
                        </Col>
                        </Row>
                    </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col style={{ width: "100%", marginBottom: "10px" }}>
                    <label htmlFor="label" className="labelInput">
                        Current Security Deposits
                    </label>
                    <Form.Item
                        name="limit"
                        hasFeedback
                        rules={[
                        {
                            required: true,
                            message: "Company Limit is required",
                        }
                        ]}
                    >
                        <Input className="inputForm" prefix="RM" disabled/>
                    </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24} style={{ marginBottom: "10px" }}>
                    <label htmlFor="label" className="labelInput">
                        Action
                    </label>
                    <Form.Item>
                        {/* Render Radio.Group to select action */}
                        <Radio.Group onChange={handleActionChange}>
                        <Radio.Button value="increase">Increase</Radio.Button>
                        <Radio.Button value="decrease">Decrease</Radio.Button>
                        </Radio.Group>
                    </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24} style={{ marginBottom: "10px" }}>
                    <label htmlFor="label" className="labelInput">
                        Amount
                    </label>
                    <Form.Item name="amount">
                        {/* Input for entering amount */}
                        <Input className="inputForm" type="number" onChange={handleAmountChange} />
                    </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24} style={{ marginBottom: "10px" }}>
                    <label htmlFor="label" className="labelInput">
                        New Limit
                    </label>
                    <Form.Item name="newSecurityLimit">
                        <Input className="inputForm" prefix="RM" disabled />
                        {/* <p style={{ display: "none" }}>{newAmount}</p> */}
                    </Form.Item>
                    </Col>
                </Row>

                <Row>
                    <Col style={{ width: "100%", marginBottom: "10px" }}>
                    <Form.Item>
                        <Row
                        style={{
                            color: "#cacaca",
                            alignItems: "center",
                            fontSize: "15px",
                        }}
                        >
                        <Col
                            span={22}
                            style={{ textAlign: "left", width: "100%" }}
                        >
                            Supporting Document
                        </Col>
                        </Row>
                    </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col style={{ marginBottom: "10px" }}>
                    <label htmlFor="label" className="labelInput">
                        Signed offer letter <span style={{ color: "red" }}>*</span>
                    </label>
                    <CustomUpload/>
                    </Col>                   
                </Row>
                <Row>
                    <Col>
                    <label htmlFor="label" className="labelInput">
                        Security deposit receipt <span style={{ color: "red" }}>*</span>
                    </label>
                    <CustomUpload/>
                    </Col>         
                </Row>
                </>
            ) : (<></>) }
        </>
    )
}

export default ReviseCreditThreshold;